/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_No_ClipInputs */

const en_us2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demonstration not available yet`)
};

const pt_br2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demonstração ainda não disponível`)
};

const es_419_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demostración aún no disponible`)
};

const pt_pt2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demonstração ainda não disponível`)
};

const fr_fr2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démonstration pas encore disponible`)
};

const de_de2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorführung noch nicht verfügbar`)
};

const it_it2_exercise_no_clip = /** @type {(inputs: Exercise_No_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimostrazione non ancora disponibile`)
};

/**
* | output |
* | --- |
* | "Demonstration not available yet" |
*
* @param {Exercise_No_ClipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_no_clip = /** @type {((inputs?: Exercise_No_ClipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_No_ClipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_no_clip(inputs)
	if (locale === "es-419") return es_419_exercise_no_clip(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_no_clip(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_no_clip(inputs)
	if (locale === "de-DE") return de_de2_exercise_no_clip(inputs)
	if (locale === "it-IT") return it_it2_exercise_no_clip(inputs)
	return en_us2_exercise_no_clip(inputs)
});
export { exercise_no_clip as "exercise.no_clip" }